"use client";
import Dropdown from "@/components/fashion/common/DropDown";
import "./style.scss";
import Link from "next/link";
import React, { useState } from "react";
import "@/components/fashion/common/utils.scss";

//? Library Imports ------------------------------------------------------------>
import { IoFilterSharp } from "react-icons/io5";
import { useUpdateSearchParameters } from "@/hooks/useUpdateParameters/useUpdateParameters";
import FilterMenu from "../FilterMenu";

export const SORTS = [
  {
    label: "Price (Low To High)",
    value: "price_asc",
  },
  {
    label: "Price (High To Low)",
    value: "price_des",
  },
  {
    label: "Newest",
    value: "newest",
  },
  {
    label: "Discounts",
    value: "discounts",
  },
  {
    label: "Top Sellers",
    value: "sellers",
  },
];

const CollectionFilterBar = ({
  subCategories,
  defaultSort = "newest",
  cols,
  filters,
  currency,
}) => {
  const { updateParams } = useUpdateSearchParameters();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleChangeSort = (value) => {
    updateParams({ key: "sort", value: value });
  };

  const handleGridCol = (cols) => {
    updateParams({ key: "cols", value: cols });
  };

  return (
    <div>
      <div className="sub-category mobile-sub-categories md-none lg-none hide-scrollbar">
        {subCategories &&
          subCategories.length > 0 &&
          subCategories.map((subCat) => (
            <Link href={`/fashion/${subCat.handle}`} key={subCat.id}>
              <div className="sub-category-button">{subCat.name}</div>
            </Link>
          ))}
      </div>
      <div className="collection-filter-bar">
        <div className="left-section">
          <div onClick={toggleMenu} className="filter-button">
            <IoFilterSharp size={17} color="#8D8D8D" /> REFINE SEARCH
          </div>

          <div className="sub-category desktop-sub-categories sm-none hide-scrollbar">
            {subCategories &&
              subCategories.length > 0 &&
              subCategories.map((subCat) => (
                <Link href={`/fashion/${subCat.handle}`} key={subCat.id}>
                  <div className="sub-category-button">{subCat.name}</div>
                </Link>
              ))}
          </div>

          {/* Sort For Mobile */}
          <div className="sort-container sm-sort-container flex md-none lg-none  items-center">
            <h4 className="sort-title">SORT BY:</h4>
            <Dropdown
              options={SORTS}
              placeholder="Choose an option"
              onChange={handleChangeSort}
              defaultValue={defaultSort}
            />
          </div>
        </div>
        <div className="right-section">
          <div className="flex items-center gap-2">
            {/*  bar container */}
            <div className="flex items-center gap-1-5">
              <div
                style={{
                  border:
                    cols === 1 ? "1px solid #C4C4C4" : "1px solid #ECECEC",
                }}
                onClick={() => handleGridCol(1)}
                className="bar-container  flex items-center lg-none"
              >
                <div
                  style={{
                    backgroundColor: cols === 1 ? "#C4C4C4" : "#ECECEC",
                  }}
                  className="bar"
                />
              </div>
              {/* Two bars */}
              <div
                style={{
                  border:
                    cols === 2 ? "1px solid #C4C4C4" : "1px solid #ECECEC",
                }}
                onClick={() => handleGridCol(2)}
                className="bar-container flex items-center"
              >
                {Array.from({ length: 2 }).map((_, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: cols === 2 ? "#C4C4C4" : "#ECECEC",
                    }}
                    className="bar"
                  />
                ))}
              </div>

              {/* Three bars */}
              <div
                style={{
                  border:
                    cols === 3 ? "1px solid #C4C4C4" : "1px solid #ECECEC",
                }}
                onClick={() => handleGridCol(3)}
                className="bar-container sm-none flex items-center"
              >
                {Array.from({ length: 3 }).map((_, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: cols === 3 ? "#C4C4C4" : "#ECECEC",
                    }}
                    className="bar"
                  />
                ))}
              </div>
              {/* Four bars */}
              <div
                style={{
                  border:
                    cols === 4 ? "1px solid #C4C4C4" : "1px solid #ECECEC",
                }}
                onClick={() => handleGridCol(4)}
                className="bar-container sm-none md-none flex items-center"
              >
                {Array.from({ length: 4 }).map((_, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: cols === 4 ? "#C4C4C4" : "#ECECEC",
                    }}
                    className="bar"
                  />
                ))}
              </div>
            </div>

            {/* Sort */}
            <div className="sort-container flex sm-none  items-center">
              <h4 className="sort-title">SORT BY:</h4>
              <Dropdown
                options={SORTS}
                placeholder="Choose an option"
                onChange={handleChangeSort}
                defaultValue={defaultSort}
              />
            </div>
          </div>
        </div>
      </div>

      <FilterMenu
        currency={currency}
        filters={filters}
        isOpen={isOpen}
        onClose={toggleMenu}
        cu
      />
    </div>
  );
};

export default CollectionFilterBar;
